<template>
  <div class="relative">
    <!-- 사용자 메뉴 버튼 -->
    <button
      @click="isOpen = !isOpen"
      class="p-0 flex items-center"
      title="사용자 메뉴"
    >
      <div class="w-8 h-8 rounded-full bg-blue-100 text-black flex items-center justify-center text-sm font-medium">
        {{ userInitial }}
      </div>
    </button>

    <!-- 드롭다운 메뉴 -->
    <div
      v-if="isOpen"
      class="absolute right-0 mt-2 w-72 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50"
    >
      <div class="px-4 py-2 border-b border-gray-200">
        <div class="font-medium break-words">{{ userName }}</div>
        <div class="text-xs text-gray-500 break-all">
          {{ userEmail }}
        </div>
        <div v-if="userTeamPosition" class="text-xs text-gray-400 mt-1">
          {{ userTeamPosition }}
        </div>
      </div>
      <!-- Debug 모드 토글 -->
      <AppDebugMode
        :model-value="debugMode"
        @update:modelValue="onDebugModeChange"
        class="border-b border-gray-200"
      />
      <button
        @click="logout"
        class="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
        title="로그아웃"
      >
        로그아웃
      </button>
    </div>
  </div>
</template>

<script>
import AppDebugMode from './DebugMode.vue'
import { ROLES_USER_MAPPING } from '@/utils/constants.js'

export default {
  name: 'AppUserMenu',
  components: { AppDebugMode },
  props: {
    userName: {
      type: String,
      required: true
    },
    userEmail: {
      type: String,
      required: true
    },
    debugMode: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    userInitial() {
      // 이름이 있으면 이름의 첫 글자, 없으면 이메일의 첫 글자, 둘 다 없으면 '?'
      if (this.userName && this.userName.trim()) {
        return this.userName.trim().charAt(0).toUpperCase();
      }
      if (this.userEmail && this.userEmail.trim()) {
        return this.userEmail.trim().charAt(0).toUpperCase();
      }
      return '?';
    },
    userTeamPosition() {
      // userEmail을 기반으로 ROLES_USER_MAPPING에서 팀/포지션 정보 찾기
      if (!this.userEmail) return null;

      const userRole = ROLES_USER_MAPPING.find(role => role.userId === this.userEmail);
      if (userRole) {
        return `${userRole.team}/${userRole.position}`;
      }
      return null;
    }
  },
  methods: {
    logout() {
      this.$emit('logout')
      this.isOpen = false
    },
    closeMenu(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
      }
    },
    onDebugModeChange(val) {
      this.$emit('update:debug-mode', val)
    }
  },
  mounted() {
    document.addEventListener('click', this.closeMenu)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeMenu)
  }
}
</script>

<style scoped>
button:focus,
button:focus-visible {
  outline: none !important;
}

button:focus div,
button:focus-visible div {
  box-shadow: 0 0 0 1px rgba(0, 123, 255, 0.836);
  border-radius: 50%;
  padding: 1px;
}
</style>